export default __webpack_public_path__ + "static/media/eyes.04fc215e.gif";